import {ISubProjectState,ISubProjectActionTypes,ISubProjectActionCreator} from 'models/ISubProjectState';

const initialState:ISubProjectState[] = []

const reducer = (state = initialState, { type, payload }: ISubProjectActionCreator) => {
    switch (type) {
      case ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;